module.exports = __webpack_public_path__ + "img/home_jypt@2x.3152d649.png";